/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
const Immutable = require('immutable');
const k = require('@gral/constants');
const App = require('@gral/app');
const Store = require('../stores/store');
const actStore = require('../actions/actStore');
const cxStore = require('../stores/cxStore');
//const notifStore = require('./notifStoreOld');
const dataStore = require('../stores/dataStore');
const i18nStore = require('../stores/i18nStore');

const _state = {
  app: Immutable.Map(),
  data: Immutable.Map(),
};

class CentralStore extends Store {
  static initClass() {
    this.prototype.storeDomain = 'central';
    this.prototype.supportedActions = [k.actionTypes.SERVER_ERROR];
  }

  getState() {
    _state.app = _state.app
      //.set('route', routeStore.getState())
      //.set('notif', notifStore.getState())
      .set('cx', cxStore.getState())
      .set('i18n', i18nStore.getState());

    _state.data = dataStore.getDataState();
    return _state;
  }

  _serverError(action) {
    const msg =
      'Unable to complete login at this time. Our servers are currently experiencing technical difficulties. Please try again later.';
    actStore.notify({
      msg,
      timeOut: 5000,
    });
    return this.emitChange(action);
  }
}
CentralStore.initClass();

module.exports = App.centralStore = new CentralStore();
